/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum RunSubmissionStatus {
    PENDING = 'Pending',
    APPROVED = 'Approved',
    REJECTED = 'Rejected',
}